(() => {
  let frame;

  const fixProductGalleryGap = () => {
    if (window.innerWidth > 767 || !document.body.classList.contains('template-product')) return;

    const info = document.querySelector('.m-main-product--info');
    const gallery = document.querySelector('.m-main-product--media .m-media-gallery__wrapper');
    const title = info?.querySelector('.m-product-title');
    if (!info || !gallery || !title) return;

    const pagination = [...gallery.querySelectorAll('.m-product-media--slider__pagination')]
      .find(node => node.getClientRects().length);
    const anchor = pagination || gallery;

    info.style.marginTop = '0px';
  };

  const scheduleFix = () => {
    fixProductGalleryGap();
    window.setTimeout(fixProductGalleryGap, 250);
    window.setTimeout(fixProductGalleryGap, 800);
  };

  scheduleFix();
  window.addEventListener('load', scheduleFix);
  window.addEventListener('resize', scheduleFix);
  document.addEventListener('shopify:section:load', scheduleFix);
  document.querySelectorAll('.m-main-product--media img').forEach(image => {
    if (!image.complete) image.addEventListener('load', fixProductGalleryGap, { once: true });
  });
})();
